/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListPhoneCompany } from '../../models/api-response-list-phone-company';

export interface CompanyNumbersList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function companyNumbersList(http: HttpClient, rootUrl: string, params: CompanyNumbersList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPhoneCompany>> {
  const rb = new RequestBuilder(rootUrl, companyNumbersList.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListPhoneCompany>;
    })
  );
}

companyNumbersList.PATH = '/v1/api/ui/company/numbers';
